module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/er-ff62e2720daee288818f6277da2a1afb.svg";